import { InvoicesPaymentWithdrawalsService } from '@festina/moneyin-general-types/moneyin/services/InvoicesPaymentWithdrawalsService'
import { useFestinaMutation } from '@festina-life/authentication'
import type { Except } from '@festina-life/core'

const method =
  InvoicesPaymentWithdrawalsService.invoicePaymentWithdrawalsServicePostPost
type MethodParam = Parameters<typeof method>[0]

export const useSubmitWithdrawPayment = ({ tenantId }: { tenantId: string }) =>
  useFestinaMutation({
    component: 'moneyIn',
    roles:
      InvoicesPaymentWithdrawalsService.invoicePaymentWithdrawalsServicePostPost_roles,
    isScenario: false,
    mutateFunction: async (arg: Except<MethodParam, 'xTenantId'>) =>
      await method({ xTenantId: tenantId, ...arg }),
  })
